import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../modules/auth/services/auth/auth.service';
import { OnboardingSessionService } from '../../../modules/onboarding/services/onboarding-session.service';

/**
 * Requires an authenticated portal session.
 * Incomplete onboarding uses its own session and must not enter the app shell.
 * Expired / missing portal sessions go to Login — never bounce SUBMITTED users
 * to Onboarding Review from the app shell.
 */
function buildLoginReturnUrl(stateUrl: string): string {
  if (typeof window === 'undefined') {
    return stateUrl;
  }
  const hash = window.location.hash;
  if (hash.includes('accessToken')) {
    return `${stateUrl}${hash}`;
  }
  return stateUrl;
}

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const onboardingSession = inject(OnboardingSessionService);

  if (authService.isAuthenticated()) {
    return true;
  }

  if (onboardingSession.isActive()) {
    const step = String(onboardingSession.getStep() ?? '')
      .trim()
      .toUpperCase();
    // Wizard finished (awaiting KYC/approval): require portal login.
    // Resume mid-wizard steps only (pre-SUBMITTED).
    if (step === 'SUBMITTED') {
      router.navigate(['/auth/login'], {
        queryParams: { returnUrl: buildLoginReturnUrl(state.url) },
      });
      return false;
    }
    router.navigateByUrl(onboardingSession.resolveResumeRoute());
    return false;
  }

  router.navigate(['/auth/login'], {
    queryParams: { returnUrl: buildLoginReturnUrl(state.url) },
  });
  return false;
};
